import { createContext } from 'react';
export var SkeletonContext = /*#__PURE__*/createContext({});